import {
  AfterViewChecked,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { ElevenLabsWidgetService } from '@shared/services/elevenlabs-widget.service';

@Component({
  selector: 'app-nuria-chat',
  templateUrl: './nuria-chat.component.html',
  styleUrls: ['./nuria-chat.component.scss'],
})
export class NuriaChatComponent implements OnInit, AfterViewChecked, OnDestroy {
  @ViewChild('messageList') messageListRef!: ElementRef<HTMLElement>;

  messages$!: ElevenLabsWidgetService['messages$'];
  status$!: ElevenLabsWidgetService['status$'];
  isOpen$!: ElevenLabsWidgetService['visible$'];
  canSendFeedback$!: ElevenLabsWidgetService['canSendFeedback$'];
  isAgentWriting$!: ElevenLabsWidgetService['isAgentWriting$'];
  inputText = '';
  feedbackRating: boolean | null = null;
  feedbackText = '';
  feedbackOpen = false;
  feedbackSent = false;
  overallRating = 0;
  overallComment = '';

  isExpanded = false;
  private shouldScroll = false;
  private destroy$ = new Subject<void>();

  constructor(private service: ElevenLabsWidgetService) {
    this.messages$ = service.messages$;
    this.status$ = service.status$;
    this.isOpen$ = service.visible$;
    this.canSendFeedback$ = service.canSendFeedback$;
    this.isAgentWriting$ = service.isAgentWriting$;
  }

  ngOnInit(): void {
    this.service.messages$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => (this.shouldScroll = true));

    this.service.isAgentWriting$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => (this.shouldScroll = true));
  }

  ngAfterViewChecked(): void {
    if (this.shouldScroll) {
      this.scrollToBottom();
      this.shouldScroll = false;
    }
  }

  send(): void {
    const text = this.inputText.trim();
    if (!text) return;
    this.service.sendMessage(text);
    this.inputText = '';
  }

  toggleFeedback(): void {
    this.feedbackOpen = !this.feedbackOpen;
    if (!this.feedbackOpen) {
      this.overallRating = 0;
      this.overallComment = '';
    }
  }

  setOverallRating(star: number): void {
    this.overallRating = star;
  }

  async sendOverallFeedback(): Promise<void> {
    if (!this.overallRating) return;
    await this.service.sendOverallFeedback(this.overallRating, this.overallComment.trim());
    this.feedbackSent = true;
    this.overallRating = 0;
    this.overallComment = '';
  }

  selectRating(like: boolean): void {
    this.feedbackRating = like;
  }

  sendFeedback(): void {
    if (this.feedbackRating === null) return;
    this.service.sendFeedback(this.feedbackRating);
    this.feedbackRating = null;
    this.feedbackText = '';
  }

  close(): void {
    this.service.close();
    this.isExpanded = false;
    this.feedbackRating = null;
    this.feedbackText = '';
    this.feedbackOpen = false;
    this.feedbackSent = false;
    this.overallRating = 0;
    this.overallComment = '';
  }

  toggleExpand(): void {
    this.isExpanded = !this.isExpanded;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.service.close();
  }

  private scrollToBottom(): void {
    try {
      const el = this.messageListRef?.nativeElement;
      if (el) el.scrollTop = el.scrollHeight;
    } catch {}
  }
}
